import SHARED_META from './shared'

export default {
  en_IE: {
    title: 'The Superdrug Online Doctor',
    meta: [
      ...SHARED_META,
      {
        name: 'description',
        content: '' // Empty description in live, adding just in case it's for some SEO reason
      },
      {
        name: 'language',
        content: 'en-ie'
      }
    ],
    link: [
      {
        rel: 'icon',
        type: 'image/ico',
        sizes: '16x16',
        href: 'https://onlinedoctor.superdrug.com/favicon.ico'
      }
    ]
  }
}
